import { useEffect } from 'react';
import usePrevious from '@elementary/common-ui/hooks/usePrevious';
import { useNavigate } from 'react-router-dom';
import useSearchParams from '@elementary/common-ui/hooks/useSearchParams';
import {
  TREE_NODE,
  DRAWER_TYPE,
  TABLE_ASSET_ID,
} from '@elementary/common-ui/constants/urlParams';

function useCatalogSidePanel() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const prevSearchParams = usePrevious(searchParams);

  // close drawer when tree_node changes
  useEffect(() => {
    if (
      searchParams.get(TREE_NODE) !== prevSearchParams?.get(TREE_NODE) &&
      searchParams.has(DRAWER_TYPE)
    ) {
      searchParams.delete(DRAWER_TYPE);
      searchParams.delete(TABLE_ASSET_ID);

      setSearchParams(searchParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, setSearchParams]);

  // close drawer when navigating from Catalog
  useEffect(
    () => () => {
      // useLocation won't work here
      const newParams = new URLSearchParams(window.location.search);

      if (newParams.has(DRAWER_TYPE)) {
        newParams.delete(DRAWER_TYPE);
        newParams.delete(TABLE_ASSET_ID);

        navigate(
          {
            pathname: window.location.pathname,
            search: newParams.toString() ? `?${newParams.toString()}` : '',
          },
          { replace: true },
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
}

export default useCatalogSidePanel;
